import { getReportParams, report } from '../../../middleware/report';

export const parentalControlReport = (actionType,status, msg, param1, customerName, id,param2,param3, subscriber, ban) => {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Parental Control';
    reportParams.channel = 'WebsitePrivate';
    reportParams.status = status;
    reportParams.actionType = actionType;
    reportParams.messageText = msg;
    reportParams.customerName = customerName;
    reportParams.idNumber = id;
    reportParams.param1 = param1;
    reportParams.param2 = param2;
    reportParams.param3 = param3;    
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;

    report(reportParams);

}